var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45786 2.36934C4.39492 2.30239 4.29288 2.30239 4.22994 2.36934L2.83879 3.84929C1.99481 4.74714 1.76289 6.10775 2.25679 7.26368C4.08935 11.5526 7.32052 14.9901 11.3521 16.9396C12.4387 17.465 13.7177 17.2183 14.5617 16.3204L15.9528 14.8405C16.0158 14.7735 16.0158 14.665 15.9528 14.598L14.0814 12.6072C14.0324 12.555 13.9574 12.542 13.8954 12.575L12.8568 13.1275C11.5777 13.8078 10.0329 13.5411 9.02176 12.4654L6.46252 9.74282C5.45133 8.66709 5.20064 7.0237 5.84018 5.66299L6.35947 4.55812C6.39049 4.49212 6.37833 4.41239 6.32928 4.36021L4.45786 2.36934ZM2.81572 0.864862C3.65971 -0.0329972 5.02809 -0.0329981 5.87208 0.864862L7.74349 2.85573C8.40126 3.55549 8.56433 4.62451 8.14832 5.50964L7.62903 6.61451C7.37449 7.15609 7.47426 7.81018 7.87673 8.23834L10.436 10.9609C10.8384 11.3891 11.4533 11.4952 11.9624 11.2244L13.0009 10.672C13.833 10.2294 14.8379 10.4029 15.4956 11.1027L17.367 13.0935C18.211 13.9914 18.211 15.4471 17.367 16.345L15.9759 17.8249C14.5424 19.3499 12.3701 19.769 10.5245 18.8765C6.0527 16.7141 2.46871 12.9014 0.436058 8.14411C-0.402825 6.18077 -0.00890672 3.86979 1.42457 2.34481L2.81572 0.864862Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.cc26091cdcba61bafc70ed9ae299e09b.svg";
export { ForwardRef as ReactComponent };